import {
  ROUTE_PATH_LIST,
  ROUTE_UI_SECTION_NAME,
  SUBMENU_PARAM_KEY,
  SUBMENU_PARAM_UNREAD_VALUE,
} from '../../constants/route'

import { BirdviewTileKey } from './DashboardBirdview.constants'

const REQUESTS_PATH = `/${ROUTE_PATH_LIST.serviceRequests}`

const MAILS_PATH = `/${ROUTE_PATH_LIST.mails}`

const DOC_FLOWS_PATH = `/${ROUTE_PATH_LIST.docFlows}`

const ACTIVITIES_PATH = `/${ROUTE_PATH_LIST.tasks}`

const BUILDINGS_PATH = `/${ROUTE_PATH_LIST.buildings}`

const CHATS_PATH = `/${ROUTE_PATH_LIST.chats}`

const DWELLER_DOCUMENTS_PATH = `/${ROUTE_PATH_LIST.documentsDweller}`

const FLATS_PATH = `/${ROUTE_PATH_LIST.flats}`

const NEWSBOARD_PATH = '/'

const UNREAD_MAILS_PATH = `${MAILS_PATH}?${SUBMENU_PARAM_KEY}=${SUBMENU_PARAM_UNREAD_VALUE}`

// A list target names its ui section, so a card can send the user to the old
// webapp while the NG app does not serve that list yet.
const REQUESTS_TARGET = {
  path: REQUESTS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.serviceRequests,
}

const UNREAD_MAILS_TARGET = {
  path: UNREAD_MAILS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.mails,
}

const ACTIVITIES_TARGET = {
  path: ACTIVITIES_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.activities,
}

const DOC_FLOWS_TARGET = {
  path: DOC_FLOWS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.docFlows,
}

const BUILDINGS_TARGET = {
  path: BUILDINGS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.buildings,
}

const CHATS_TARGET = {
  path: CHATS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.chats,
}

const DWELLER_DOCUMENTS_TARGET = {
  path: DWELLER_DOCUMENTS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.documentsDweller,
}

const FLATS_TARGET = {
  path: FLATS_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.flats,
}

const NEWSBOARD_TARGET = {
  path: NEWSBOARD_PATH,
  sectionName: ROUTE_UI_SECTION_NAME.newsboard,
}

// TODO The lists do not take filters from the URL yet: once the backend contract
// exists, each drill-out must open its list pre-filtered the way the tile counts
// (open statuses, staff_member scope, overdue / without provider).
export const BIRDVIEW_TILE_TARGET = {
  [BirdviewTileKey.Backlog]: REQUESTS_TARGET,
  [BirdviewTileKey.Input]: REQUESTS_TARGET,
  [BirdviewTileKey.NoProvider]: REQUESTS_TARGET,
  [BirdviewTileKey.Overdue]: REQUESTS_TARGET,
  [BirdviewTileKey.Unassigned]: REQUESTS_TARGET,
  [BirdviewTileKey.Unread]: UNREAD_MAILS_TARGET,
}

export const BIRDVIEW_SECTION_TARGET = {
  activities: ACTIVITIES_TARGET,
  attention: REQUESTS_TARGET,
  communication: UNREAD_MAILS_TARGET,
  criticalRequests: REQUESTS_TARGET,
  docFlows: DOC_FLOWS_TARGET,
  dwellerAnnouncements: NEWSBOARD_TARGET,
  dwellerDocuments: DWELLER_DOCUMENTS_TARGET,
  dwellerMessages: CHATS_TARGET,
  dwellerObjects: FLATS_TARGET,
  properties: BUILDINGS_TARGET,
  requests: REQUESTS_TARGET,
  teamLoad: REQUESTS_TARGET,
}
